import { MARKETING_TRACKING_TTL_MS } from '~/stores/apostatudo/marketing-tracking';

export type User = { id?: string };
export type Device = { fingerprint?: string };

export type Utm = {
  source?: string;
  medium?: string;
  campaign?: string;
  id?: string;
  term?: string;
  content?: string;
};

export type GoogleAttribution = {
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
};

export type FacebookAttribution = {
  fbclid?: string;
  fbc?: string;
  fbp?: string;
};

export type TiktokAttribution = { ttclid?: string };

export type AptAttribution = {
  channel?: string;
  content?: string;
  extra?: string;
};

// Substitui completamente o estado do target pelos campos de values.
// Chaves antigas presentes em target são removidas se ausentes em
// values. Útil para espelhar o estado do marketing-tracking (quando
// marketing esvazia um grupo, o journey também deve esvaziar).
const replaceAll = <T extends object>(target: T, values: T) => {
  Object.keys(target).forEach((key) => {
    delete (target as Record<string, unknown>)[key];
  });
  Object.assign(target, values);
};

const isExpired = (timestamp: number | null | undefined) =>
  timestamp != null && Date.now() - timestamp > MARKETING_TRACKING_TTL_MS;

export const useUserJourneyStore = defineStore(
  'ap.userJourney',
  () => {
    const user = reactive<User>({});
    const device = reactive<Device>({});
    const utm = reactive<Utm>({});
    const google = reactive<GoogleAttribution>({});
    const facebook = reactive<FacebookAttribution>({});
    const tiktok = reactive<TiktokAttribution>({});
    const apt = reactive<AptAttribution>({});

    const acquiredAt = ref<number | null>(null);

    const setAcquiredAt = (value: number | null) => {
      acquiredAt.value = value;
    };

    const resetAll = () => {
      [user, device, utm, google, facebook, tiktok, apt].forEach((target) => {
        Object.keys(target).forEach((key) => {
          delete (target as Record<string, unknown>)[key];
        });
      });
      acquiredAt.value = null;
    };

    return {
      user,
      device,
      utm,
      google,
      facebook,
      tiktok,
      apt,
      acquiredAt,
      setUser: (value: User) => replaceAll(user, value),
      setDevice: (value: Device) => replaceAll(device, value),
      setUtm: (value: Utm) => replaceAll(utm, value),
      setGoogle: (value: GoogleAttribution) => replaceAll(google, value),
      setFacebook: (value: FacebookAttribution) => replaceAll(facebook, value),
      setTiktok: (value: TiktokAttribution) => replaceAll(tiktok, value),
      setApt: (value: AptAttribution) => replaceAll(apt, value),
      setAcquiredAt,
      resetAll,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
      afterHydrate: (ctx) => {
        const store = ctx.store as ReturnType<typeof useUserJourneyStore>;

        if (isExpired(store.acquiredAt)) {
          store.resetAll();
        }
      },
    },
  },
);
